import { render, staticRenderFns } from "./td-4d-arr-number.vue?vue&type=template&id=2e580d70&"
import script from "./td-4d-arr-number.vue?vue&type=script&lang=js&"
export * from "./td-4d-arr-number.vue?vue&type=script&lang=js&"
import style0 from "./td-4d-arr-number.vue?vue&type=style&index=0&id=2e580d70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports